import { createHistory } from 'history';

const browserHistory = createHistory();

// react-router-dom v5's Router expects history.location (history v4 API),
// but history v3 only has getCurrentLocation(). Bridge the gap.
Object.defineProperty(browserHistory, 'location', {
  get() { return browserHistory.getCurrentLocation(); },
  enumerable: true,
  configurable: true,
});

export { browserHistory };
export default browserHistory;
